export default __webpack_public_path__ + "static/media/club-bg-smd.26b09881.svg";